export enum FeedbackSubjectType {
  EVENT = 'event',
  EXHIBIT = 'exhibit',
  TRAIL = 'trail',
}